import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";

import type { DocumentTemplateResource } from "@exonn/js-sdk";
import type { ModuleOptions } from "src/system/module.types.ts";

export const module: ModuleOptions<DocumentTemplateResource> = {
  resource: ResourceEnum.DocumentTemplate,
  bigIcon: <span className={"icon-20-dok_templ"} />,
  smallIcon: <span className={"icon-15-dok_templ"} />,
  tabs: {
    edit: {
      getTitle: (resource) => resource.name,
    },
  },
};
